import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDatabase, faStethoscope, faClipboardCheck, faMoneyBillWave, faGift, faExclamationTriangle, faMinusCircle, faBed, 
  faBandAid, faMapMarkerAlt,faMoneyCheck, faBullhorn, faChalkboardTeacher, faTasks, faUserSlash, faClock, faAmbulance, faCertificate,
  faIdCard
} from '@fortawesome/free-solid-svg-icons';
import './ThinkContract.css';

function ThinkContractWorkers() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 flex flex-col items-center py-8">
        <p className="text-xl font-bold text-white text-center mb-4">Workers Dashboard </p>

        <div className="flex-grow">
          <div className="grid grid-cols md:grid-cols lg:grid-cols-5 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkButton to="/myprofile-blueprofile" icon={faDatabase} label="Master Record" />
            <LinkButton to="/contact-genious/blue" icon={faIdCard} label="Blue Card" />
            <LinkButton to="/chronocheck-home" icon={faClipboardCheck} label="Attendance" />
            <LinkNoButton to="" icon={faMoneyBillWave} label="Salary & Wages" />
            <LinkNoButton to="" icon={faGift} label="Bonus" />
            <LinkNoButton to="" icon={faExclamationTriangle} label="Fine" />
            <LinkNoButton to="" icon={faMinusCircle} label="Deductions" />
            <LinkNoButton to="" icon={faMoneyCheck} label="Advance" />
            <LinkNoButton to="" icon={faBullhorn} label="Grievances" />
            <LinkNoButton to="" icon={faChalkboardTeacher} label="Trainings" />
            <LinkNoButton to="" icon={faTasks} label="Tasks" />
            <LinkNoButton to="" icon={faUserSlash} label="Terminations" />
            <LinkNoButton to="" icon={faClock} label="Overtime" />
            <LinkNoButton to="" icon={faAmbulance} label="Accidents" />
            <LinkNoButton to="" icon={faBed} label="Rest Days" />
            <LinkNoButton to="" icon={faCertificate} label="Skill Certificate" />
            <LinkNoButton to="" icon={faStethoscope} label="Medical Examinations" />
            <LinkNoButton to="" icon={faBandAid} label="Injury" />
            <LinkNoButton to="" icon={faMapMarkerAlt} label="Work Location" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkContractWorkers;
